import React, { useEffect, useState } from "react";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import matchesBg from "./images/three_steps_bg.png";
import joined1 from "./images/joined1.jpg";
import joined2 from "./images/joined2.jpg";
import joined3 from "./images/joined3.jpg";
import joined4 from "./images/joined4.jpg";

const FALLBACK_TESTIMONIALS = [
  {
    name: "NAVEEN",
    location: "DELHI",
    message:
      "I am fully satisfied by the online matrimonial service provided by Hindu Sanjog.",
    image: joined1,
  },
  {
    name: "PREETI",
    location: "UTTARAKHAND",
    message:
      "Very easy to use and user friendly website. Thank you Hindu Sanjog for providing me platform for choosing my life partner.",
    image: joined2,
  },
  {
    name: "VIPIN",
    location: "HARYANA",
    message:
      "I recommend Hindu Sanjog to my friends and relatives because its gives you opportunity to mingle with your like minded match.",
    image: joined3,
  },
  {
    name: "SNEHA",
    location: "PUNJAB",
    message:
      "Found my perfect life partner through Hindu Sanjog. The verified profiles gave my family great confidence.",
    image: joined4,
  },
];

const ForeverJourney = () => {
  const [testimonials, setTestimonials] = useState(FALLBACK_TESTIMONIALS);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}admin-mat/api/testimonial.php`)
      .then((response) => {
        let list = [];
        if (Array.isArray(response.data)) {
          list = response.data;
        } else if (response.data && Array.isArray(response.data.data)) {
          list = response.data.data;
        }
        if (list.length > 0) {
          setTestimonials(list);
        }
      })
      .catch((error) => {
        console.error("Error fetching testimonials:", error);
      });
  }, []);

  const displayList =
    testimonials && testimonials.length > 0 ? testimonials : FALLBACK_TESTIMONIALS;

  return (
    <section className="forever-journey-section">
      <div className="forever-journey-inner">
        {/* Top Heart & Flourish Ornament */}
        <div className="forever-ornament-top">
          <svg width="140" height="24" viewBox="0 0 140 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 12C32 12 40 4 52 4C58 4 62 12 66 12" stroke="#e53d5c" strokeWidth="1.2" strokeLinecap="round" opacity="0.6"/>
            <path d="M125 12C108 12 100 4 88 4C82 4 78 12 74 12" stroke="#e53d5c" strokeWidth="1.2" strokeLinecap="round" opacity="0.6"/>
            <circle cx="25" cy="12" r="2" fill="#e53d5c" opacity="0.6"/>
            <circle cx="115" cy="12" r="2" fill="#e53d5c" opacity="0.6"/>
            <path d="M70 19L68.5 17.6C63.2 12.8 59.7 9.6 59.7 5.7C59.7 3.3 61.5 1.5 63.8 1.5C65.1 1.5 66.4 2.1 67.2 3.1L70 6.3L72.8 3.1C73.6 2.1 74.9 1.5 76.2 1.5C78.5 1.5 80.3 3.3 80.3 5.7C80.3 9.6 76.8 12.8 71.5 17.6L70 19Z" stroke="#e53d5c" strokeWidth="1.8" fill="none"/>
          </svg>
        </div>

        {/* Section Heading */}
        <div className="forever-header-wrap">
          <h2 className="forever-main-title">
            A Journey To Forever – <span className="forever-brand-highlight">Hindu Sanjog</span>
          </h2>

          <div className="forever-divider-motif">
            <svg width="80" height="16" viewBox="0 0 80 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 8H28M52 8H80" stroke="#d4a373" strokeWidth="1" strokeLinecap="round"/>
              <circle cx="40" cy="8" r="4.5" stroke="#d4a373" strokeWidth="1.2" fill="none"/>
              <circle cx="34" cy="8" r="2" fill="#d4a373"/>
              <circle cx="46" cy="8" r="2" fill="#d4a373"/>
            </svg>
          </div>

          <p className="forever-subtitle">
            Real stories. Real people. Real connections that turned into a lifetime of happiness.
          </p>
        </div>

        {/* Testimonials Slider */}
        <div className="forever-slider-wrapper">
          <button
            type="button"
            className="forever-nav-btn forever-nav-prev"
            aria-label="Previous testimonials"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="15 18 9 12 15 6" />
            </svg>
          </button>

          <button
            type="button"
            className="forever-nav-btn forever-nav-next"
            aria-label="Next testimonials"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </button>

          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            navigation={{
              prevEl: ".forever-nav-prev",
              nextEl: ".forever-nav-next",
            }}
            pagination={{
              clickable: true,
              el: ".forever-pagination",
            }}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            loop={displayList.length >= 3}
            spaceBetween={28}
            slidesPerView={1.15}
            breakpoints={{
              640: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 28,
              },
            }}
          >
            {displayList.map((t, index) => {
              const avatarSrc = t.image
                ? t.image.startsWith("http") || t.image.startsWith("data:") || t.image.startsWith("/static")
                  ? t.image
                  : `${process.env.REACT_APP_API_BASE_URL || ""}${t.image}`
                : index % 4 === 0
                ? joined1
                : index % 4 === 1
                ? joined2
                : index % 4 === 2
                ? joined3
                : joined4;

              return (
                <SwiperSlide key={index}>
                  <div className="forever-testimonial-card">
                    {/* Bottom-right Corner Botanical Art */}
                    <div className="card-botanical-corner">
                      <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M60 60C45 55 35 45 30 30C35 40 45 45 60 60Z" fill="#e53d5c" opacity="0.15"/>
                        <path d="M60 40C48 38 40 30 35 18C38 28 48 32 60 40Z" fill="#e53d5c" opacity="0.12"/>
                        <path d="M40 60C38 48 30 40 18 35C28 38 32 48 40 60Z" fill="#e53d5c" opacity="0.12"/>
                      </svg>
                    </div>

                    <div className="forever-quote-icon">“</div>

                    <p className="forever-quote-text">
                      {t.message || t.text || "Very helpful and trustworthy matrimonial service."}
                    </p>

                    <div className="quote-heart-divider">
                      <span className="divider-line" />
                      <span className="divider-heart">♥</span>
                    </div>

                    <div className="forever-card-footer">
                      <div className="author-info-group">
                        <img
                          src={avatarSrc}
                          alt={t.name}
                          className="author-avatar-img"
                          onError={(e) => {
                            e.target.src = joined1;
                            e.target.onerror = null;
                          }}
                        />
                        <div className="author-text-meta">
                          <strong className="author-name-text">{t.name}</strong>
                          <span className="author-location-text">{t.location || "INDIA"}</span>
                        </div>
                      </div>

                      <span className="footer-floating-heart">♥</span>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>

          {/* Custom Pagination Container */}
          <div className="forever-pagination" />
        </div>
      </div>

      <style>{`
        .forever-journey-section {
          position: relative;
          padding: 65px 0 60px;
          background-color: #faf6f4;
          background-image: url(${matchesBg});
          background-size: cover;
          background-position: center center;
          background-repeat: no-repeat;
          overflow: hidden;
        }

        .forever-journey-inner {
          max-width: 1240px;
          margin: 0 auto;
          padding: 0 30px;
          position: relative;
          z-index: 2;
        }

        .forever-ornament-top {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 6px;
        }

        .forever-header-wrap {
          text-align: center;
          margin-bottom: 36px;
        }

        .forever-main-title {
          font-family: 'Playfair Display', Georgia, 'Times New Roman', serif;
          font-size: 2.35rem;
          font-weight: 700;
          color: #1e242d;
          margin: 0 0 6px;
          letter-spacing: -0.01em;
          line-height: 1.25;
        }

        .forever-brand-highlight {
          color: #e53d5c;
          font-family: inherit;
          font-weight: 700;
        }

        .forever-divider-motif {
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 8px 0 10px;
        }

        .forever-subtitle {
          font-family: 'Outfit', 'Plus Jakarta Sans', -apple-system, sans-serif;
          font-size: 1rem;
          color: #667085;
          margin: 0;
          font-weight: 400;
        }

        .forever-slider-wrapper {
          position: relative;
          padding: 4px 6px 12px;
        }

        /* Navigation Buttons */
        .forever-nav-btn {
          position: absolute;
          top: 48%;
          transform: translateY(-50%);
          width: 44px;
          height: 44px;
          border-radius: 50%;
          background: #ffffff;
          border: 1px solid rgba(229, 61, 92, 0.15);
          box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
          color: #e53d5c;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          z-index: 10;
          transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
          outline: none;
        }

        .forever-nav-prev {
          left: -20px;
        }

        .forever-nav-next {
          right: -20px;
        }

        .forever-nav-btn:hover {
          background: #e53d5c;
          color: #ffffff;
          box-shadow: 0 6px 20px rgba(229, 61, 92, 0.3);
          transform: translateY(-50%) scale(1.08);
        }

        .forever-nav-btn.swiper-button-disabled {
          opacity: 0.3;
          pointer-events: none;
        }

        .forever-slider-wrapper .swiper {
          padding: 10px 4px 20px;
          overflow: visible;
        }

        .forever-slider-wrapper .swiper-slide {
          height: auto;
          display: flex;
        }

        /* Testimonial Card */
        .forever-testimonial-card {
          background: #ffffff;
          border-radius: 22px;
          padding: 30px 28px 24px;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
          border: 1px solid #f2e9e9;
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 100%;
          min-height: 290px;
          transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1);
          overflow: hidden;
        }

        .forever-testimonial-card:hover {
          transform: translateY(-6px);
          border-color: rgba(229, 61, 92, 0.3);
          box-shadow: 0 16px 36px rgba(229, 61, 92, 0.12);
        }

        .card-botanical-corner {
          position: absolute;
          bottom: 0;
          right: 0;
          pointer-events: none;
          z-index: 1;
        }

        .forever-quote-icon {
          font-family: 'Playfair Display', Georgia, serif;
          font-size: 2.6rem;
          line-height: 1;
          color: #e53d5c;
          font-weight: 700;
          margin-bottom: 14px;
          display: block;
        }

        .forever-quote-text {
          font-family: 'Playfair Display', Georgia, serif;
          font-style: italic;
          font-size: 1.02rem;
          color: #334155;
          line-height: 1.65;
          margin: 0 0 18px;
          flex-grow: 1;
          position: relative;
          z-index: 2;
        }

        /* Divider line with heart */
        .quote-heart-divider {
          display: flex;
          align-items: center;
          gap: 6px;
          margin-bottom: 18px;
          position: relative;
          z-index: 2;
        }

        .quote-heart-divider .divider-line {
          width: 42px;
          height: 1px;
          background: #ffccd5;
        }

        .quote-heart-divider .divider-heart {
          color: #e53d5c;
          font-size: 0.75rem;
          opacity: 0.8;
        }

        /* Card Footer */
        .forever-card-footer {
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;
          z-index: 2;
        }

        .author-info-group {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .author-avatar-img {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          object-fit: cover;
          border: 2px solid #ffffff;
          box-shadow: 0 4px 12px rgba(229, 61, 92, 0.22);
          flex-shrink: 0;
        }

        .author-text-meta {
          display: flex;
          flex-direction: column;
          text-align: left;
        }

        .author-name-text {
          font-family: 'Outfit', 'Plus Jakarta Sans', -apple-system, sans-serif;
          font-size: 0.95rem;
          font-weight: 700;
          color: #1e293b;
          text-transform: uppercase;
          letter-spacing: 0.02em;
          line-height: 1.2;
        }

        .author-location-text {
          font-family: 'Outfit', 'Plus Jakarta Sans', -apple-system, sans-serif;
          font-size: 0.76rem;
          font-weight: 600;
          color: #94a3b8;
          text-transform: uppercase;
          letter-spacing: 0.04em;
          margin-top: 2px;
        }

        .footer-floating-heart {
          color: #e53d5c;
          opacity: 0.25;
          font-size: 0.9rem;
        }

        /* Pagination Dots */
        .forever-pagination {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          margin-top: 22px;
          position: relative;
          z-index: 5;
        }

        .forever-pagination .swiper-pagination-bullet {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #d8d0cd;
          opacity: 0.8;
          transition: all 0.3s ease;
          margin: 0 !important;
          cursor: pointer;
        }

        .forever-pagination .swiper-pagination-bullet-active {
          background: #e53d5c !important;
          width: 10px;
          height: 10px;
          opacity: 1;
          box-shadow: 0 2px 8px rgba(229, 61, 92, 0.4);
        }

        @media (max-width: 1024px) {
          .forever-journey-section {
            padding: 50px 0 45px;
          }

          .forever-main-title {
            font-size: 1.95rem;
          }

          .forever-nav-prev {
            left: -8px;
          }

          .forever-nav-next {
            right: -8px;
          }
        }

        @media (max-width: 768px) {
          .forever-journey-section {
            padding: 40px 0 35px;
          }

          .forever-main-title {
            font-size: 1.65rem;
          }

          .forever-subtitle {
            font-size: 0.92rem;
          }

          .forever-nav-btn {
            display: none;
          }

          .forever-journey-inner {
            padding: 0 16px;
          }

          .forever-testimonial-card {
            padding: 24px 20px 20px;
            border-radius: 18px;
          }

          .forever-quote-text {
            font-size: 0.95rem;
          }
        }
      `}</style>
    </section>
  );
};

export default ForeverJourney;
